"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferImage = void 0;
const transferImage = ({ httpClient, }) => ({ image_id, region, }) => {
    const path = '/images';
    const url = `${path}/${image_id}/actions`;
    const body = { type: 'transfer', region };
    return httpClient.post(url, body);
};
exports.transferImage = transferImage;
//# sourceMappingURL=transfer-image.js.map